"use client";
import { StaticAccordion, TranslationData } from "@/common/lib/types";
import React, { FC, HTMLAttributes, useState } from "react";
import StaticAccordianView from "@/components/static/StaticAccordianView";

interface ISeoFooterTextProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  accordionContent?: StaticAccordion;
  translations?: TranslationData;
}

const SeoFooterText: FC<ISeoFooterTextProps> = (props) => {
  const { title, description, accordionContent, translations } = props;

  const [readMore, setReadMore] = useState(false);

  return (
    <div className="container mx-auto mt-8 flex w-full flex-col items-center px-4 md:mt-[60px] md:px-8">
      {title && <h2 className="mb-4 text-center text-[22px] font-semibold">{title}</h2>}
      
      {description && (
        <div className="w-full">
          <div
            className={`text-center [&>*:not(p)+*:not(p)]:mt-2.5 [&_a]:underline [&_h2]:text-[22px] [&_h2]:font-semibold [&_h3]:text-xl [&_h3]:font-semibold [&_h4]:text-lg [&_h4]:font-medium [&_h5]:text-base [&_h5]:font-medium [&_li]:w-fit [&_li]:text-sm [&_li]:md:text-base [&_ol]:flex [&_ol]:list-decimal [&_ol]:flex-col [&_ol]:items-center [&_ol]:pl-6 [&_p]:text-sm [&_p]:md:text-base [&_ul]:flex [&_ul]:list-disc [&_ul]:flex-col [&_ul]:items-center [&_ul]:pl-6 ${!readMore ? "line-clamp-3 overflow-hidden" : ""}`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <span
            onClick={() => setReadMore((pre) => !pre)}
            className="mt-4 block cursor-pointer text-center text-base font-semibold underline"
          >
            {readMore
              ? (translations?.common?.common_show_less_label ?? "Show Less")
              : (translations?.common?.common_read_more_label ?? "Read More")}
          </span>
        </div>
      )}

      {accordionContent && (
        <div className="mt-8 w-full [&>*:not(p)+*:not(p)]:mt-2.5">
          <StaticAccordianView
            className="!px-0"
            content={accordionContent}
            classNames={{
              accordion: {
                title: "!text-sm md:!text-base",
                container:
                  "!text-sm md:!text-base !px-4 md:!pb-1.5 !border-b !border-t-0 md:!mt-4 !border-solid !border-tertiary-3",
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SeoFooterText;
